<div class="list-question-item__container">
  <empathy-list-item-button
    [text]="question().code + '. ' + question().title"
    [icon]="questionTypeConfig[question().type].icon"
    [active]="active()"
    [showCheckbox]="selectMode$() && question().type !== questionType.HiddenChoice"
    [checked]="selectedIds$().has(question()?.id)"
    (clicked)="activate.emit(question().id)"
    (checkedChange)="onSelectQuestion($event)"
  ></empathy-list-item-button>

  @if (movePositionAllowed()) {
    <empathy-positioning-actions [questionId]="question().id" [isFirst]="isFirst()" [isLast]="isLast()" />
  }
</div>
